import React, { useMemo, useCallback, useEffect, useRef } from 'react'
import { toast } from 'react-toastify';
import './counter-widget.scss';
import { initializeIconFallbacks } from './iconFallback';

function CustomCounterWidget({count, setCount, stock, flowRef}) {
    const counterRef = useRef(null);

    // Memoize button disabled states to prevent unnecessary re-renders
    const isDecrementDisabled = useMemo(() => 
        count === (flowRef === 'pdp' ? 1 : 0), 
        [count, flowRef]
    );

    const isIncrementDisabled = useMemo(() => 
        count >= stock, 
        [count, stock]
    );

    // Initialize icon fallbacks after component mounts
    useEffect(() => {
        if (counterRef.current) {
            // Small delay to ensure DOM is fully rendered
            const timer = setTimeout(() => {
                initializeIconFallbacks(counterRef.current);
            }, 50);
            
            return () => clearTimeout(timer);
        }
    }, []);

    // Use useCallback to prevent function recreation on every render
    const handleIncrement = useCallback((e) => {
        e.preventDefault();
        if((count + 1) <= stock)
            setCount(prevCount => prevCount + 1)
        //else
            // toast.error(`Only ${stock} available in stock`);
    }, [count, stock, setCount]);

    const handleDecrement = useCallback((e) => {
        e.preventDefault();
        // For cart items, allow decrementing to 0 (which will remove the item)
        // For PDP, minimum is 1
        const minCount = flowRef === 'pdp' ? 1 : 0;
        if (count > minCount) {
            setCount(prevCount => prevCount - 1);
        }
    }, [count, setCount, flowRef]);

  return (
    <div className='bs-counter-widget' ref={counterRef}>
        <div className='bs-counter-widget__wrapper'>
            <button 
                className='bs-counter-widget__action-button bs-counter-widget__decrement-btn'
                onClick={handleDecrement}
                disabled={isDecrementDisabled}
                aria-label="Decrease quantity"
                type="button"
            >
                <span className='icon icon-decrement bs-counter-widget__icon' aria-hidden="true"></span>
            </button>
            <div className='bs-counter-widget__input-wrap'>
                <input 
                    type="number" 
                    className='bs-counter-widget__input' 
                    value={count} 
                    readOnly
                    aria-label="Product quantity"
                />
            </div>
            <button 
                className='bs-counter-widget__action-button bs-counter-widget__increment-btn'
                onClick={handleIncrement}
                disabled={isIncrementDisabled}
                aria-label="Increase quantity"
                type="button"
            >
                <span className='icon icon-increment bs-counter-widget__icon' aria-hidden="true"></span>
            </button>
        </div>
    </div>
  )
}

export default CustomCounterWidget